import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { ToastService, ToastMessage } from '../../services/toast.service';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('toastAnim', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(16px) translateX(-50%)' }),
                animate('280ms cubic-bezier(0.16, 1, 0.3, 1)', style({ opacity: 1, transform: 'translateY(0) translateX(-50%)' })),
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(8px) translateX(-50%)' })),
            ]),
        ]),
    ],
    standalone: false
})
export class ToastComponent implements OnInit, OnDestroy {
  toast: ToastMessage | null = null;
  visible = false;
  private sub!: Subscription;
  private timeout: any;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.sub = this.toastService.toast$.subscribe((t) => {
      clearTimeout(this.timeout);
      this.toast = t;
      this.visible = true;

      this.timeout = setTimeout(() => {
        this.visible = false;
      }, t.duration || 3000);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    clearTimeout(this.timeout);
  }

  get icon(): string {
    const icons: Record<string, string> = {
      success: 'check_circle',
      error: 'error',
      info: 'info',
      warning: 'warning',
    };
    return icons[this.toast?.type || 'info'];
  }

  dismiss(): void {
    this.visible = false;
  }
}
